import { render, staticRenderFns } from "./propertyCard.vue?vue&type=template&id=0bde80ce&scoped=true&lang=html&"
import script from "./propertyCard.vue?vue&type=script&lang=js&"
export * from "./propertyCard.vue?vue&type=script&lang=js&"
import style0 from "./propertyCard.vue?vue&type=style&index=0&id=0bde80ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde80ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VIcon,VProgressCircular,VSpacer,VSwitch})
